import accessibleAutocomplete from 'accessible-autocomplete';

const getSuggestionLabel = (result) => {
  if (typeof result === 'string') {
    return result;
  }

  return result?.label || '';
};

const fetchSuggestions = (query, done, postType = '') => {
  fetch(search_autocomplete.url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
    body: new URLSearchParams({
      action: search_autocomplete.action,
      searchString: query,
      postType,
      nonce: search_autocomplete.nonce,
    }),
  })
    .then((res) => res.json())
    .then((data) => done(data.results || []))
    .catch((err) => {
      console.error(err);
      done([]);
    });
};

document.querySelectorAll('.autocompleteSearch').forEach((el) => {
  const { id, placeholder, name = 's', postType = '' } = el.dataset;
  if (!id) {
    console.warn('Autocomplete element missing data-id', el);
    return;
  }

  // Ensure any labels that referenced the original id point to the generated input.
  document.querySelectorAll(`label[for="${id}"]`).forEach((label) => {
    label.setAttribute('for', `${id}__input`);
  });

  accessibleAutocomplete({
    element: el,
    id,
    name,
    placeholder,
    minLength: 2,
    templates: {
      inputValue(result) {
        return getSuggestionLabel(result);
      },
      suggestion(result) {
        const label = getSuggestionLabel(result);
        if (result?.url) {
          return `<a href="${result.url}">${label}</a>`;
        }

        return label;
      },
    },
    onConfirm(result) {
      if (postType === 'course' && result?.url) {
        window.location.href = result.url;
      }
    },
    source(query, done) {
      if (!query || query.length < 2) {
        done([]);
        return;
      }
      fetchSuggestions(query, done, postType);
    },
  });
});
